import styled from 'styled-components';
import DatePicker from 'react-datepicker';
export const styles = {
    container: {
        height: '100%',
        marginTop: 50,
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
    },
    title: {
        marginLeft: 10,
        fontWeight: 'bold',
    },
    divider: {
        borderBottomWidth: 1,
        height: 5,
    },
    sectionContainer: {
        marginTop: 15,
        width: '98%',
        alignItems: 'center',
        marginLeft: 10,
    },
    card: {
        backgroundColor: "#EEF2F7",
        padding: "0.8rem",
    },
    cardHeader: {
        backgroundColor: "#F8F8F9",
        fontWeight: "700",
        borderTopRightRadius: "5px",
        borderTopLeftRadius: "5px",
    },

    cardTitle: {
        fontSize: "16px",
        fontWeight: "600",
        lineHeight: "16px",
        color: "#0160F1",
    },
    cardContent: {
        backgroundColor: "#FFFFFF",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        fontSize: 15,
        // paddingTop: 5,
    },
    label: {
        fontSize: 15,
    },
    select: {
        maxWidth: 250,
        minWidth: 250,
        fontSize: 15,
        whiteSpace: "normal",
        wordWrap: "break-word",
        overflow: "hidden",
    },
    menuItem: {
        fontSize: 15,
    },
    formControl: {
        maxWidth: 250,
        minWidth: 250,
    },
    downloadButtonContainer: {
        display: "flex",
        justifyContent: "flex-end",
    },
    locationCodeCardHeader: {
        backgroundColor: "#F8F8F9",
        fontWeight: "700",
        borderTopRightRadius: "5px",
        borderTopLeftRadius: "5px",
    },
    locationCardContent: {
        backgroundColor: "#FFFFFF",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        fontSize: 15,
    },
    blankBox: {
        display: "flex",
        alignItems: "center",
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "16px",
        marginLeft: "1rem",
    },
    fullWidth: {
        width: "100%"
    },
    buttonBox: {
        display: "flex",
        alignItems: "center",
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "16px",
        marginLeft: "1rem",
    },
    deviderStyle: {
        marginRight: 2,
        marginLeft: 2,
        backgroundColor: "#c0c0c0",
        width: 2,
    },
    whiteBackgrnd: {
        backgroundColor: "white"
    },
    redColor: {
        color: "red"
    },
    saveDataButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: 5,
        marginRight: '0.7rem'
    },
    downloadAssetMasterButton: {
        marginTop: 2,
        marginBottom: 1,
        marginLeft: 70
    },
    fileNameCell: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        wordBreak: 'break-word',
        whiteSpace: 'normal',
    },
    loaderOverlay: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 10
    },

};

export const StyledDatePicker = styled(DatePicker)`
  width: 200px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  font-size: 14px;
  color: #333;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  box-sizing: border-box;
`;

export const boxSX = {
    textDecoration: "none",
    "&:hover": {
        cursor: "pointer",
        textDecoration: "underline",
        color: "darkblue",
    },
};



